// extracted by mini-css-extract-plugin
export var buttonTabGroup = "TabGroup-module--buttonTabGroup--jUvjm";
export var lightButtonTabGroup = "TabGroup-module--lightButtonTabGroup--O4WMy";